import store from '../redux/store';

import {loginUser, logoutUser, changePasswordChallenge} from '../redux/actionCreators/ActionCreatorsAuth';
import {setBucketValue} from '../redux/actionCreators/ActionCreatorsBucket';
import {fetchClients, fetchAllClients, postClient, patchClient} from '../redux/actionCreators/ActionCreatorsClients';
import {fetchSubcontractedBCU, fetchSubcontracted, fetchClientSubcontractanti, postClientSubcon, patchClientSubcon } from "../redux/actionCreators/ActionCreatorsClientsSubcon";
import {fetchUsers, postUser, patchUser} from '../redux/actionCreators/ActionCreatorsUsers';
import {fetchEmployersForClient, fetchEmployer, postEmployer, patchEmployer} from '../redux/actionCreators/ActionCreatorsEmployers';
import {fetchWorksitesForEmployer, fetchWorksitesForClient, postEmployerWorksite, patchEmployerWorksite} from '../redux/actionCreators/ActionCreatorsEmployerWorksites';
import {fetchEmployees, postEmployee, patchEmployee} from '../redux/actionCreators/ActionCreatorsEmployees';
import {fetchAuthzs} from '../redux/actionCreators/ActionCreatorsAuthorizations';
import {postAuthISCIR, patchAuthISCIR, patchAuthzsStampDate} from '../redux/actionCreators/ActionCreatorsAuthorizations';
import { postAuthzIscirImage } from "../redux/actionCreators/ActionCreatorsAuthorizations"; 
import {postAuthzInternal, patchAuthzInternal, patchAuthzsCertDate} from '../redux/actionCreators/ActionCreatorsAuthorizations';
import { postAuthzInternalCert } from "../redux/actionCreators/ActionCreatorsAuthorizations";
import {fetchCourses, postEmployeeCourse, patchEmployeeCourse, postEmployeeCourseCert} from '../redux/actionCreators/ActionCreatorsEmployeeCourses';
import {fetchRsvtiTasks, postRsvtiTask, patchRsvtiTask} from '../redux/actionCreators/ActionCreatorsRsvtiTasks';
import { fetchRsvtiOperators } from "../redux/actionCreators/ActionCreatorsRsvtiOperators";
import {fetchCorCodes} from '../redux/actionCreators/ActionCreatorsStaticData';


export const DispatchAF = {

    // Authentication
    loginUser: (authData, onLoginCallback) => store.dispatch(loginUser(authData, onLoginCallback)),
    logoutUser: () => store.dispatch(logoutUser()),
    changePasswordChallenge: (authCredentials) => store.dispatch(changePasswordChallenge(authCredentials)),
    // Bucket
    setBucketValue: (value) => store.dispatch(setBucketValue(value)),
    // Clients
    // fetchClients: () => dispatch(fetchClients()),
    fetchAllClients: () => store.dispatch(fetchAllClients()),
    postClient: (client) => store.dispatch(postClient(client)),
    patchClient: (client) => store.dispatch(patchClient(client)),
    // Client Subcontractors
    fetchSubcontractedBCU: (clientId) => store.dispatch(fetchSubcontractedBCU(clientId)),
    fetchSubcontracted: (clientId) => store.dispatch(fetchSubcontracted(clientId)),
    fetchClientSubcontractanti: (clientId) => store.dispatch(fetchClientSubcontractanti(clientId)),
    postClientSubcon: (subcon) => store.dispatch(postClientSubcon(subcon)),
    patchClientSubcon: (subcon) => store.dispatch(patchClientSubcon(subcon)),
    // Users
    fetchUsers: (clientId) => store.dispatch(fetchUsers(clientId)),
    postUser: (user) => store.dispatch(postUser(user)),
    patchUser: (user, clientId) => store.dispatch(patchUser(user, clientId)),
    // Employers
    fetchEmployersForClient: (clientId) => store.dispatch(fetchEmployersForClient(clientId)),
    fetchEmployer: (employerId) => store.dispatch(fetchEmployer(employerId)),
    postEmployer: (employer) => { store.dispatch(postEmployer(employer)) },
    patchEmployer: (employer) => store.dispatch(patchEmployer(employer)),
    // Employer Work-Sites
    // fetchEmployerWorksites: (params) => store.dispatch(fetchEmployerWorksites(params)),
    fetchWorksitesForEmployer: (employerId) => store.dispatch(fetchWorksitesForEmployer(employerId)),
    fetchWorksitesForClient: (clientId) => store.dispatch(fetchWorksitesForClient(clientId)),
    postEmployerWorksite: (worksite) => store.dispatch(postEmployerWorksite(worksite)),
    patchEmployerWorksite: (worksite) => store.dispatch(patchEmployerWorksite(worksite)),

    // Employees
    fetchEmployees: (employerId) => store.dispatch(fetchEmployees(employerId)),
    postEmployee: (employee) => store.dispatch(postEmployee(employee)),
    patchEmployee: (employee) => store.dispatch(patchEmployee(employee)),
    // Authorizations
    fetchAuthzs: (employeeId) => store.dispatch(fetchAuthzs(employeeId)),
    // Authorizations - ISCIR
    postAuthISCIR: (authorization, reminder) => store.dispatch(postAuthISCIR(authorization, reminder)),
    patchAuthISCIR: (authorization, reminder) => store.dispatch(patchAuthISCIR(authorization, reminder)),
    patchAuthzsStampDate: (employerId, updatedAuthzArray, notUpdatedAuthzArray, stampDate) => store.dispatch(patchAuthzsStampDate(employerId, updatedAuthzArray, notUpdatedAuthzArray, stampDate)),
    postAuthzIscirImage:(fileName, imageBase64, employerId, employeeId, authzId, imageType) => store.dispatch(postAuthzIscirImage(fileName, imageBase64, employerId, employeeId, authzId, imageType)),
    // Authorizations - Internal
    postAuthzInternal: (authorization, reminder) => store.dispatch(postAuthzInternal(authorization, reminder)),
    patchAuthzInternal: (authorization, reminder) => store.dispatch(patchAuthzInternal(authorization, reminder)),
    patchAuthzsCertDate: (taskId, clientId, employerId, updatedAuthzArray, notUpdatedAuthzArray, stampDate) => store.dispatch(patchAuthzsCertDate(taskId, clientId, employerId, updatedAuthzArray, notUpdatedAuthzArray, stampDate)),
    postAuthzInternalCert: (fileName, certBase64, employerId, employeeId, authzId) => store.dispatch(postAuthzInternalCert(fileName, certBase64, employerId, employeeId, authzId)),
    // Courses
    fetchCourses: (employeeId) => store.dispatch(fetchCourses(employeeId)),
    postEmployeeCourse: (course) => store.dispatch(postEmployeeCourse(course)),
    patchEmployeeCourse: (course) => store.dispatch(patchEmployeeCourse(course)),
    postEmployeeCourseCert: (fileName, certBase64, employerId, employeeId, courseId) => store.dispatch(postEmployeeCourseCert(fileName, certBase64, employerId, employeeId, courseId)),
    // RSVTI Task
    fetchRsvtiTasks: (clientId) => store.dispatch(fetchRsvtiTasks(clientId)),
    postRsvtiTask: (task) => store.dispatch(postRsvtiTask(task)),
    patchRsvtiTask: (task) => store.dispatch(patchRsvtiTask(task)),
    // RSVTI Operators
    fetchRsvtiOperators: (clientId, worksiteId) => store.dispatch(fetchRsvtiOperators(clientId, worksiteId)),
    // Static Data
    fetchCorCodes: () => store.dispatch(fetchCorCodes()),
    
}